import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'
import { Button } from '@interco/inter-ui/components/Button'
import { Text } from '@interco/inter-ui/components/Text'
import Warning from '@interco/icons/core/status/ic_warning_circle'
import { useTrackingRefin } from '@hooks'
import { StepRefin } from '@utils/enums'
import { Colors } from '@utils/Colors'

import { useSiapeAuthorizationSheet } from '../useSiapeAuthorizationSheet'
import { Buttons, Container, Header, IconContainer } from './styles'

interface SecondAttemptBottomSheetProps {
  onDismiss: () => void
  onConfirmAuthorization: () => void
  onRetryMarginResult: () => void
}

export const SecondAttemptBottomSheet = ({
  onDismiss,
  onConfirmAuthorization,
  onRetryMarginResult,
}: SecondAttemptBottomSheetProps) => {
  useTrackingRefin(StepRefin.CONSULTA_MARGEM_SEGUNDA_TENTATIVA)

  const { handleAccessSouGov, handleConfirmAuthorization } = useSiapeAuthorizationSheet({
    attempt: 'second',
    onConfirmAuthorization,
    onRetryMarginResult,
  })

  return (
    <BottomSheet onClose={onDismiss} noSwipe>
      <Container>
        <Header>
          <IconContainer aria-hidden="true">
            <Warning height={64} width={64} color={Colors.ALERT500} />
          </IconContainer>
          <Text variant="body-2" bold colorWeight={500}>
            Autorize a consulta de margem para prosseguir com a sua contratação
          </Text>
          <Text variant="body-3">
            Acesse o SouGov e autorize a consulta para que possamos te oferecer as melhores
            condições e uma contratação 100% digital.
          </Text>
        </Header>
      </Container>
      <Buttons>
        <Button fullWidth onClick={handleAccessSouGov}>
          Acessar SouGov
        </Button>
        <Button fullWidth variant="secondary" onClick={handleConfirmAuthorization}>
          Já autorizei
        </Button>
      </Buttons>
    </BottomSheet>
  )
}
